<div class="container-fluid main_header">
    <div class="header container">
        <div class="logo"><img src="assets/img/beLIVE.png" alt=""></div>
        <div class="logout">Logout</div>
    </div>
</div>


<div class="subtitle container">
    <h1>Account Setup</h1>
    Please fill in the below details so that we can setup an account for your organisation
    in our system and give you access to the Do-It-Yourself portal for listing your event.
</div>

<div class="container mt-5">

    <!-- Tabs -->

    <div class="tabs_content">
        <ul class="nav custom-tabs" id="myTab" role="tablist">
            <li class="nav-item">
                <!-- <button class="nav-link active" id="tab1-tab" data-bs-toggle="tab" data-bs-target="#tab1" type="button"> -->
                <button class="nav-link" [class.active]="currentStep === 1" (click)="goStep(1)">
                    1. General Information
                </button>
            </li>

            <li class="nav-item">
                <!-- <button class="nav-link" id="tab2-tab" data-bs-toggle="tab" data-bs-target="#tab2" type="button"> -->
                <button class="nav-link" [class.active]="currentStep === 2" (click)="goStep(2)">
                    2. Upload Documents
                </button>
            </li>

            <li class="nav-item">
                <!-- <button class="nav-link" id="tab3-tab" data-bs-toggle="tab" data-bs-target="#tab3" type="button"> -->
                <button class="nav-link" [class.active]="currentStep === 3" (click)="goStep(3)">
                    3. Sign Agreement
                </button>
            </li>
        </ul>
    </div>

    <!-- Tab Content -->
    <form [formGroup]="homeForm" (ngSubmit)="submitForm()">
        <div class="tab-content pt-4">

            <!-- Tab 1 -->
            <!-- <div class="tab-pane fade show active" id="tab1"> -->
            <div class="tab-pane" [class.show]="currentStep === 1" [class.active]="currentStep === 1">
                <div class="first_section">
                    <div class="container p-0">

                        <div class="section-title">Organisation Details</div>


                        <div class="step-content active">

                            <div class="card">

                                <div class="mb-4">
                                    <h6 class="fw-bold">Organiser Profile</h6>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input custom-check" type="radio"
                                            name="organiserProfile" formControlName="organiserProfile" value="company">
                                        <label class="form-check-label">Company / Organisation</label>
                                    </div>

                                    <br>

                                    <div class="form-check form-check-inline">
                                        <input class="form-check-input custom-check" type="radio"
                                            name="organiserProfile" formControlName="organiserProfile"
                                            value="individual">
                                        <label class="form-check-label">Individual</label>
                                    </div>
                                </div>


                                <div class="form-grid1">
                                    <div class="form-group">
                                        <label>Display Name</label>
                                        <input placeholder="Enter Name" formControlName="displayName"> <br>

                                        <label class="form-label mt-2">About Organiser (50 - 120 Words)</label>
                                        <textarea id="wordTextarea" class="form-control" rows="3"
                                            formControlName="aboutOrganiser"
                                            placeholder="Type your message here (50 to 120 words)...">
                                    </textarea>
                                        <small id="wordCount" class="text-muted">Words: 0</small>
                                    </div>


                                    <div class="pan_card">

                                        <label>Upload Logo</label>

                                        <div class="upload-box text-center p-4">
                                            <div class="mb-2">
                                                <i class="bi bi-cloud-arrow-up upload-icon"></i>
                                            </div>

                                            <!-- <img src="assets/img/noun-upload-3141434 1.png" alt=""> -->

                                            <p class="mb-1 fw-semibold">Choose a file or drag & drop it here.</p>
                                            <small class="text-muted">JPEG, JPG and PNG formats, up to 3 MB</small>

                                            <div class="mt-3 up_btn">
                                                <div class="upload">
                                                    <button class="upload__btn">Upload a file</button>
                                                    <input formControlName='uploadFile' class="upload__input"
                                                        type="file" name="myfile"
                                                        (change)="handleBrochureInput($event)" />
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <!-- GSTIN Section -->


                            </div>
                            <div class="section-title">Contact Person Details</div>
                            <div class="card">

                                <div class="form-grid">
                                    <div class="form-group">
                                        <label>First Name</label>
                                        <input type="text" placeholder="First Name" formControlName="fName">
                                    </div>
                                    <div class="form-group">
                                        <label>Last Name</label>
                                        <input type="text" placeholder="Last Name" formControlName="lName">
                                    </div>
                                    <div class="form-group">
                                        <label>Work Email</label>
                                        <input type="emial" placeholder="Work Email" formControlName="wEmail">
                                    </div>

                                    <div class="form-group">
                                        <label>Mobile Number</label>

                                        <div class="input-group">
                                            <!-- Mobile Number Input -->
                                            <input type="tel" class="form-control" placeholder="Enter Mobile Number"
                                                formControlName="mNumber">

                                            <!-- Country Code Dropdown -->
                                            <div class="input-group-append">
                                                <select class="form-select country-code" formControlName="cCode">
                                                    <option value="+91">🇮🇳 +91</option>
                                                    <option value="+1">🇺🇸 +1</option>
                                                    <option value="+44">🇬🇧 +44</option>
                                                    <option value="+61">🇦🇺 +61</option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div class="section-title">Bank details</div>
                            <div class="card">

                                <div class="form-grid">
                                    <div class="form-group">
                                        <label>Country</label>
                                        <select formControlName="bankAccount">
                                            <option disabled>Select account type</option>
                                            <option>Current account</option>
                                            <option>Saving account</option>
                                            <option>Salary account</option>
                                            <option>NRI account</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <label>Emirate</label>
                                        <input placeholder="Enter account number" formControlName="emirate">
                                    </div>
                                    <div class="form-group">
                                        <label>IFSC</label>
                                        <input placeholder="Enter Bank IFSC" formControlName="bankIFSC">
                                    </div>
                                </div>
                            </div>

                            <div class="buttons">
                                <button class="btn save">Save details</button>
                                <button class="btn proceed" type="button" (click)="goStep(2)">Proceed</button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>

            <!-- Tab 2 -->
            <!-- <div class="tab-pane fade" id="tab2"> -->
            <div class="tab-pane" [class.show]="currentStep === 2" [class.active]="currentStep === 2">
                <div class="second_tab step-content">
                    <div class="card">
                        <div class="row ">

                            <div class="card">

                                <div class="form-grid">
                                    <div class="form-group">
                                        <label>Registered Legal Name</label>
                                        <input type="text" placeholder="Registered Legal Name"
                                            formControlName="registeredLegalName">
                                    </div>
                                    <div class="form-group">
                                        <label>Trade License Number</label>
                                        <input type="text" placeholder="Trade License Number"
                                            formControlName="tradeLicenseNumber">
                                    </div>


                                    <div class="form-group">
                                        <label>Country</label>
                                        <select formControlName="accountType">
                                            <option disabled>Select account type</option>
                                            <option>DED</option>
                                            <option>Free Zone Authority</option>
                                            <option>Other</option>
                                        </select>
                                    </div>

                                    <div class="form-group">
                                        <label class="form-label mt-2">Registered Address (UAE)</label>
                                        <textarea id="wordTextarea" class="form-control" rows="3"
                                            placeholder="Type your message here (50 to 120 words)..."
                                            formControlName="registeredAddressUAE">
                                    </textarea>
                                        <small id="wordCount" class="text-muted">Words: 0</small>
                                    </div>

                                    <div class="hk-toggle hk-tg-2">
                                        <input type="checkbox" id="tg2" formControlName="isVatRegistered">

                                        <label for="tg2"></label>
                                        <span> &nbsp; &nbsp; VAT Registered? </span>

                                    </div>

                                    <div *ngIf="homeForm.get('isVatRegistered')?.value" class="mt-2">
                                        <label>VAT Number</label>
                                        <input type="text" class="form-control" placeholder="Enter VAT Number"
                                            formControlName="vatNumber" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card">

                        <div class="form-grid one_col">
                            <div class="pan_card">

                                <label> Trade License Copy (upload) </label>

                                <div class="upload-box text-center p-4">
                                    <div class="mb-2">
                                        <i class="bi bi-cloud-arrow-up upload-icon"></i>
                                    </div>

                                    <!-- <img src="assets/img/noun-upload-3141434 1.png" alt=""> -->

                                    <p class="mb-1 fw-semibold">Choose a file or drag & drop it here.</p>
                                    <small class="text-muted">JPEG, JPG and PNG formats, up to 3 MB</small>

                                    <div class="mt-3 up_btn">
                                        <div class="upload">
                                            <button class="upload__btn">Upload a file</button>
                                            <input formControlName='tradeLicenseCopyUpload' class="upload__input"
                                                type="file" name="myfile2" (change)="handleBrochureInput2($event)" />
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="pan_card">

                                <label> Authorised Signatory ID (upload)</label>

                                <div class="upload-box text-center p-4">
                                    <div class="mb-2">
                                        <i class="bi bi-cloud-arrow-up upload-icon"></i>
                                    </div>

                                    <!-- <img src="assets/img/noun-upload-3141434 1.png" alt=""> -->

                                    <p class="mb-1 fw-semibold">Choose a file or drag & drop it here.</p>
                                    <small class="text-muted">JPEG, JPG and PNG formats, up to 3 MB</small>

                                    <div class="mt-3 up_btn">
                                        <div class="upload">
                                            <button class="upload__btn">Upload a file</button>
                                            <input formControlName='authorisedSignatoryIDUpload' class="upload__input"
                                                type="file" name="myfile3" (change)="handleBrochureInput3($event)" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                    <div class="card">
                        <div class="form-grid">

                            <div class="form-group"><label>Signatory Name</label>
                                <input formControlName="signatoryName" placeholder="Enter Signatory Name">
                            </div>
                            <div class="form-group"><label>Designation</label>
                                <input formControlName="signatoryDesignation" placeholder="Enter Your Designation">
                            </div>
                            <div class="form-group"><label>Email</label>
                                <input formControlName="signatoryEmail" placeholder="Enter Email Address">
                            </div>
                            <div class="form-group"><label>Mobile </label>
                                <input formControlName="signatoryMobile" placeholder="Enter Mobile No.">
                            </div>
                        </div>
                    </div>

                    <div class="card">
                        <div class="form-grid">
                            <div class="form-group"><label> Full Legal Name </label>
                                <input placeholder="Enter account number" formControlName="fullLegalName">
                            </div>

                            <div class="form-group">
                                <label>Nationality</label>
                                <select formControlName="legalNameNationality">
                                    <option disabled>Select account type</option>
                                    <option>Aus</option>
                                    <option>IND</option>
                                    <option>Other</option>
                                </select>
                            </div>

                            <div class="hk-toggle hk-tg-2">
                                <input type="checkbox" id="tg3" formControlName="isUaeResident"
                                    formControlName="residentInUAE">
                                <label for="tg3"></label>
                                <span> &nbsp; &nbsp; Resident In UAE? </span>
                            </div>

                            <div *ngIf="homeForm.get('isUaeResident')?.value; else passportBlock">
                                <!-- Emirates ID Number -->
                                <div class="uae-col">
                                    <label>Emirates ID Number</label>
                                    <input type="text" class="form-control" placeholder="Enter Emirates ID Number"
                                        formControlName="emiratesIDNumber" />
                                </div>

                                <!-- Emirates ID Upload -->
                                <div class="uae-col">
                                    <div class="pan_card">
                                        <label>Emirates ID Copy (upload)</label>

                                        <div class="upload-box text-center p-4">
                                            <!-- <img src="assets/img/noun-upload-3141434 1.png" alt=""> -->
                                            <p class="mb-1 fw-semibold">
                                                Choose a file or drag & drop it here.
                                            </p>
                                            <small class="text-muted">
                                                JPEG, JPG and PNG formats, up to 3 MB
                                            </small>

                                            <div class="mt-3 up_btn">
                                                <div class="upload">
                                                    <button class="upload__btn">Upload a file</button>

                                                    <input formControlName='emiratesFileUpload' class="upload__input"
                                                        type="file" name="myfile4"
                                                        (change)="handleBrochureInput4($event)" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <ng-template #passportBlock>

                                <div class="mt-2">
                                    <label>Passport Number</label>
                                    <input type="text" class="form-control" placeholder="Enter Passport Number"
                                        formControlName="passportNumber" />
                                </div>

                                <div class="pan_card mt-3">
                                    <label>Passport Copy (upload)</label>

                                    <div class="upload-box text-center p-4">
                                        <!-- <img src="assets/img/noun-upload-3141434 1.png" alt=""> -->
                                        <p class="mb-1 fw-semibold">
                                            Choose a file or drag & drop it here.
                                        </p>
                                        <small class="text-muted">
                                            JPEG, JPG and PNG formats, up to 3 MB
                                        </small>

                                        <div class="mt-3 up_btn">
                                            <div class="upload">
                                                <button class="upload__btn">Upload a file</button>
                                                <input formControlName='passportFileUpload' class="upload__input"
                                                    type="file" name="myfile5"
                                                    (change)="handleBrochureInput5($event)" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>


                    <div class="card">
                        <div class="form-grid one_col">

                            <div class="form-group">
                                <label class="form-label mt-2">Address</label>
                                <textarea id="wordTextarea" class="form-control" rows="3"
                                    placeholder="Type your message here (50 to 120 words)..." formControlName="address">
                                    </textarea>
                                <small id="wordCount" class="text-muted">Words: 0</small>
                            </div>



                        </div>


                        <div class="form-grid one_col">
                            <div class="form-group"><br>
                                <label>Country</label>
                                <select formControlName="country">
                                    <option disabled>Select account type</option>
                                    <option>Aus</option>
                                    <option>IND</option>
                                    <option>Other</option>
                                </select>
                            </div>

                            <div class="form-group"><br>
                                <label>City</label>
                                <select formControlName="city">
                                    <option disabled>Select account type</option>
                                    <option>Aus</option>
                                    <option>IND</option>
                                    <option>Other</option>
                                </select>
                            </div>

                            <div class="mt-4">
                                <h6 class="fw-bold">Will any events serve alcohol?</h6>
                                <div class="form-check form-check-inline">
                                    <input name="willAnyEventsServeAlcohol" formControlName="willAnyEventsServeAlcohol" type="radio"
                                        id="gstYes" value="Yes" class="form-check-input custom-check">
                                    <!-- data-bs-toggle="modal" data-bs-target="#gstModal"  -->


                                    <label for="gstYes" class="form-check-label">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input name="willAnyEventsServeAlcohol" formControlName="willAnyEventsServeAlcohol" type="radio" value="No" class="form-check-input custom-check" id="gstNo">
                                    <label for="gstNo" class="form-check-label">No</label>
                                </div>
                            </div>


                            <div class="mt-4">
                                <h6 class="fw-bold">Will you host 18+ events?</h6>
                                <div class="form-check form-check-inline">
                                    <input name="willYouHostEvents" formControlName="willYouHostEvents" type="radio"
                                        id="18+Yes" value="Yes" class="form-check-input custom-check">
                                    <!-- data-bs-toggle="modal" data-bs-target="#gstModal"  -->


                                    <label for="18+Yes" class="form-check-label">Yes</label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input name="willYouHostEvents" formControlName="willYouHostEvents" type="radio" value="No" class="form-check-input custom-check" id="18+No">
                                    <label for="18+No" class="form-check-label">No</label>
                                </div>
                            </div>

                        </div>
                    </div>


                    <div class="parent_button">
                        <div class="back">
                            <button> Back </button>
                        </div>
                        <div class="buttons save_details">
                            <button class="btn save">Save details</button>
                            <button class="btn proceed" type="submit" (click)="goStep(2);">Proceed</button>
                        </div>
                    </div>

                </div>
            </div>

            <!-- Tab 3 -->
            <!-- <div class="tab-pane fade" id="tab3"> -->
            <div class="tab-pane" [class.show]="currentStep === 3" [class.active]="currentStep === 3">

                <div class="thankyou_content step-content">
                    <h4> Thank you for your details! </h4>
                    <p> We have received your application. Your application is currently getting reviewed by our team.
                        We
                        will get back to you
                        in 2-3 business days </p>

                    <span> Incase of any query, please write to <a href="#"> bd@beliveevent.com </a> </span>
                </div>
            </div>

        </div>
    </form>
</div>


<!-- popup -->




<div class="modal fade" id="gstModal" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Header -->
            <div class="modal-header d-flex justify-content-between align-items-center">

                <!-- Left Text -->
                <h5 class="modal-title fw-bold">
                    GST Declaration
                </h5>

                <!-- Right Logo -->
                <img src="assets/img/beLIVE.png" height="35" alt="logo">

            </div>

            <!-- Body -->
            <div class="modal-body text-center">

                <p class="text-muted mb-4">
                    I/We, Organizer, do confirm and acknowledge that I am/We are a supplier providing services through
                    an e commerce platform as per Section 24(1X) of the Central Goods and Services Tax under the
                    prevalent GST regime ("GST Laws") and confirm that I/We are not registered under the GST Act, since
                    our annual turnover is below the threshold limit of Rs. 20 Lakhs (supplier supply only services).
                    I/We confirm that any applicable taxes collected on the Tickets booked through Bigtree Entertainment
                    Pvt. Ltd.'s platform i.e. www.bookmyshow.com and/or its mobile application and/or other sales
                    channels is our liability and the same shall be duly discharged by us.
                    I/We acknowledge that information furnished above are true to the best of my/our knowledge and that
                    we shall be bound by the acts of duly constituted attorney. In case any of the above information is
                    found to be incorrect at a later date, my membership with your platform shall stand cancelled and
                    any payment or unprocessed bill shall be withheld by you on the basis of the statements given herein
                    above, I/We request you to permit and allow our event to be listed on your platform. I/We shall
                    indemnify and hold harmless you and your officers, representatives, affiliates, successors and
                    assigns, against all costs, penalties, damages, or losses or any other charges, penalties, or
                    liabilities incurred in relation to any claim raised pursuant to the following:
                </p>

                <button class="btn btn-danger px-4">
                    Confirm & Continue
                </button>

            </div>

        </div>
    </div>
</div>